import React, { useState, useEffect, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import HydrantDeficiencyTableRow from '../../components/hydrantDeficiencies/HydrantDeficiencyTableRow';
import CircleButton from '../../components/CircleButton';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { addHydrantDeficiency, deleteHydrantDeficiency } from '../../services/api';
import { getHydrantDeficiencies, getHydrantDeficienciesByHydrantId } from '../../services/api';
import AddHydrantDeficiencyModal from './AddHydrantDeficiencyModal';
import EditHydrantDeficiencyModal from './EditHydrantDeficiencyModal';

const HydrantDeficiencies = () => {
  const [loading, setLoading] = useState(true);
  const [hydrantDeficiencies, setHydrantDeficiencies] = useState([]);
  const [addHydrantDeficiencyModalOpen, setAddHydrantDeficiencyModalOpen] = useState(false);
  const { hydrantId } = useParams();

  useEffect(() => {
    setupHydrantDeficiencies();
  }, [hydrantId]);

  const setupHydrantDeficiencies = async () => {
    setLoading(true);
    const result = await getHydrantDeficienciesByHydrantId(hydrantId);
    console.log('Hydrant Deficiencies', result);
    const resultSorted = result?.sort((a, b) => a.resolved === b.resolved ? (a.name <= b.name ? -1 : 1) : a.resolved ? 1 : -1) ?? [];
    setHydrantDeficiencies(resultSorted);
    setLoading(false);
  };

  const handleDelete = async id => {
    await deleteHydrantDeficiency(id);
    await setupHydrantDeficiencies();
  };

  const handleAddHydrantDeficiency = async (id) => {
    setAddHydrantDeficiencyModalOpen(false);
    await setupHydrantDeficiencies();
  };

  const handleEdit = async () => {
    await setupHydrantDeficiencies();
  };
  
  const rows = hydrantDeficiencies.map((c, idx) => (
    <HydrantDeficiencyTableRow key={idx} hydrantDeficiency={c} onDelete={() => handleDelete(c.id)} onEdit={handleEdit} />
  ));

  return (
    <div className="hydrant-deficiencies">
      <h2>Hydrant Deficiencies</h2>
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Type</th>
              <th>Note</th>
              <th>Resolved</th>
              <th className='command-row'>
                <CircleButton icon={faPlus} type="success" title="Add Deficiency" onClick={() => setAddHydrantDeficiencyModalOpen(true)} />
              </th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      )}
      <AddHydrantDeficiencyModal open={addHydrantDeficiencyModalOpen} hydrantId={hydrantId} onCancel={() => setAddHydrantDeficiencyModalOpen(false)} onComplete={handleAddHydrantDeficiency} />
    </div>
  );
};

export default HydrantDeficiencies;